const i18nOptions = {
    lng: "en",
    interpolation: {
        escapeValue: false,
    },
    supportedLngs: ["en", "gr"],
    fallbackLng: "en",
    nonExplicitSupportedLngs: true,
    debug: process.env.NODE_ENV === "development",
    backend: {
        loadPath: undefined,
    },
};

export default i18nOptions;
